export const AGECRO_WINTER = {
  value: 1,
  key: "importExport.agecro.sessionTypes.winter"
};
export const AGECRO_SUMMER = {
  value: 2,
  key: "importExport.agecro.sessionTypes.summer"
};
export const AGECRO_FALL = {
  value: 3,
  key: "importExport.agecro.sessionTypes.fall"
};


export default [AGECRO_WINTER, AGECRO_SUMMER, AGECRO_FALL];


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/agecroSessionTypes.js